import {View} from 'MWC';
import Model from '../models/corezoid.m.js';
import tpl from '../templates/interactive.jsx';
import queries from '../queries/corezoid.q';
const data = {
    contactPhoneNumber: '+38 (0'
};

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);
        this.state = {
            activeScreen: 'form',
            model: new Model(data)
        };

        this.attribute = this.props.attribute;
        this.utmMarks = this.props.utmParams ? this.props.utmParams : '';
        this.entity = this.props.entity || 'legal';
        this.query = queries;
    }

    handleChange = event => {
        const data = {
            name: event.target.name,
            value: event.target.value
        };

        this._run(data);
    };

    selectItem = name => {
        const model = this.getModel();
        const data = {
            name: name,
            value: !model.fields.agree.value
        };

        this._run(data);
    };

    onBlurHandle = name => {
        const model = this.getModel();
        model.changeFirst(name);
        model.validate();
        this.setState({model});
    };

    _run = data => {
        const model = this.getModel(),
            {name, value} = data;

        model.run({name, value});
        this.setState({model});
    };

    handleEscape = event => {
        if (event.keyCode === 27) {
            this.closeModal();
        }
    };

    closeModal = event => {
        event ? event.stopPropagation() : this.props.closeModal();

        const target = event && event.target,
            classesToClose = ['form-wrapper', 'close-button'];

        if (target && classesToClose.some(className => target.classList.contains(className))) {
            this.props.closeModal();
        }
    };

    removeBracketsAndSpaces(phoneNumber) {
        phoneNumber = phoneNumber.replace(/\(/g, '').replace(/\)/g, '');

        phoneNumber = phoneNumber.replace(/\s/g, '');

        return phoneNumber;
    }

    sendForm = async () => {
        const model = this.getModel();
        const data = {
            phone: this.removeBracketsAndSpaces(model.fields.contactPhoneNumber.value),
            name: model.fields.name.value,
            mail: model.fields.email.value,
            site: model.fields.customerNameOrCite.value,
            product: this.attribute,
            entity: this.entity,
            utmMarks: this.utmMarks
        };
        await this.query.sendForm(data);
        const activeScreen = this.query.activeScreen;
        this.setState({activeScreen});
    };

    componentDidMount() {
        window.addEventListener('keydown', this.handleEscape);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleEscape);
    }

    static displayName = 'Green.Card.Order';
}
